/* global window, document */
'use strict';

/**
 * Copy of $().ready from jQuery 3.2.x
 */
const readyCallbacks = [];
let isReady = false;

let whenReady = (fn) => {
    readyCallbacks.push(fn);
};

function onReady() {
    if (isReady) {
        return;
    }
    isReady = true;

    whenReady = function (fn) {
        readyCallbacks.push(fn);

        while (readyCallbacks.length) {
            const funct = readyCallbacks.shift();

            if (funct) {
                funct.call(document);
            }
        }
    };

    whenReady();
}

/**
 * The ready event handler and self cleanup method
 */
function completed() {
    document.removeEventListener('DOMContentLoaded', completed);
    window.removeEventListener('load', completed);
    onReady();
}

// Catch cases where $(document).ready() is called
// after the browser event has already occurred.
// Support: IE9-10 only
// Older IE sometimes signals 'interactive' too soon
if (document.readyState === 'complete' || document.readyState !== 'loading' && !document.documentElement.doScroll) {
    // Handle it asynchronously to allow scripts the opportunity to delay ready
    window.setTimeout(onReady);
} else {
    // Use the handy event callback
    document.addEventListener('DOMContentLoaded', completed);

    // A fallback to window.onload, that will always work
    window.addEventListener('load', completed);
}

export default function (fn) {
    whenReady(fn);
}
